import { AxiosPromise } from 'axios';
import {
  IGetTimetables,
  IGetDailyTimetables,
  IRollbookReq,
  IGetTimetable,
  ITimetableReq,
  IGetRollbook,
} from '../models/campusClasses3.model';
import axios from 'axios';

const uri = '/mgmt/campus-classes';

// 시간표 내 특정 일정의 상세내역을 가져온다
export const getDetailTimetable = (
  timetableCode: string,
): AxiosPromise<IGetTimetable> => {
  return axios.get(`${uri}/classes/${timetableCode}/change-day`);
};

export const getDetailTimetable2 = (
  timetableCode: string,
): AxiosPromise<IGetTimetable> => {
  return axios.get(`${uri}/classes/${timetableCode}/change-day2`);
};

// 시간표 내 일정 목록을 가져온다
export const getTimetables = (
  classCode: string,
): AxiosPromise<IGetTimetables> => {
  return axios.get(`${uri}/${classCode}/timetables`);
};

// 특정 날짜의 출석부 정보를 가져온다
export const getRollbook = (
  classCode: string,
  timetableCode: string,
): AxiosPromise<IGetRollbook> => {
  return axios.get(`${uri}/${classCode}/attendance/${timetableCode}`);
};

export const getDailyTimetables = (
  classCode: string,
  timetableCode: string,
): AxiosPromise<IGetDailyTimetables> => {
  return axios.get(`${uri}/${classCode}/${timetableCode}/timetables`);
};

// 특정 날짜의 출석부 정보를 업데이트한다
export const updateRollbook = (
  classCode: string,
  timetableCode: string,
  data: IRollbookReq[],
): AxiosPromise => {
  return axios.post(`${uri}/${classCode}/attendance/${timetableCode}`, data);
};

// 출석부 첨부파일을 업로드한다
export const uploadRollbookFile = (
  classCode: string,
  timetableCode: string,
  data: any,
): AxiosPromise => {
  return axios.put(`${uri}/${classCode}/attendance/${timetableCode}`, data);
};

// 시간표 내 특정 일정을 업데이트한다
export const updateTimetable = (
  timetableCode: string,
  data: ITimetableReq,
): AxiosPromise => {
  return axios.put(`${uri}/classes/${timetableCode}/change-day`, data);
};
